<!-- Sticky shell: announcement strip + white header. Sticky (not fixed) so it
     reserves its own space — no spacer, no layout jump. -->
<div class="ns" [class.ns--open]="megaOpen">
  <!-- 1. thin announcement strip (dark teal, centred, editable via component) -->
  <div class="ns-announce" *ngIf="announcement">
    <span>{{ announcement }}</span>
  </div>

  <!-- 2. main white header -->
  <header class="ns-header">
    <div class="ns-inner">
      <a class="ns-logo" routerLink="/" (click)="closeAll()" aria-label="PlateX home">
        <img src="assets/logo-black-text.svg" alt="PlateX" />
      </a>

      <!-- launch (staging / www): compact dropdowns + PlateViewer; saved plates is the heart
             by the search, the account is Sign in / the person icon -->
      <nav class="ns-nav" aria-label="Primary" *ngIf="launch">
        <div class="ns-drop" *ngFor="let m of launchMenus">
          <button
            type="button"
            class="ns-nav-item"
            [class.is-active]="openDrop === m.id"
            (click)="toggleDrop(m.id)"
            aria-haspopup="true"
            [attr.aria-expanded]="openDrop === m.id"
          >
            {{ m.label }}<span class="ns-caret" aria-hidden="true"></span>
          </button>
          <div class="ns-drop-menu" *ngIf="openDrop === m.id">
            <a *ngFor="let l of m.links" [routerLink]="l.route" (click)="closeAll()">{{ l.label }}</a>
          </div>
        </div>
        <a class="ns-nav-item" routerLink="/plate-viewer" routerLinkActive="is-active is-active--route" (click)="closeAll()">PlateViewer</a>
      </nav>

      <!-- desktop top-level nav -->
      <nav class="ns-nav" aria-label="Primary" *ngIf="!launch">
        <button
          type="button"
          class="ns-nav-item ns-nav-search"
          [class.is-active]="megaOpen"
          (click)="toggleMega()"
          aria-haspopup="true"
          [attr.aria-expanded]="megaOpen"
        >
          Search<span class="ns-caret" aria-hidden="true"></span>
        </button>
        <ng-container *ngFor="let item of topNav">
          <a
            *ngIf="item.route; else soonItem"
            class="ns-nav-item"
            [routerLink]="item.route"
            [queryParams]="item.queryParams"
            [routerLinkActive]="item.live ? 'is-active is-active--route' : ''"
            (click)="closeAll()"
            >{{ item.label
            }}<span class="ns-live" *ngIf="item.live && liveCount !== null" [attr.aria-label]="liveCount + ' live lots'"
              ><i></i>{{ liveCount }}</span
            ></a
          >
          <ng-template #soonItem>
            <span class="ns-nav-item ns-nav-item--soon" title="Coming soon"
              >{{ item.label }}<span class="ns-soon">soon</span></span
            >
          </ng-template>
        </ng-container>
      </nav>

      <!-- right: compact search + account icons + mobile burger -->
      <div class="ns-actions">
        <form class="ns-search" (submit)="$event.preventDefault(); runSearch()">
          <input
            class="ns-search-input"
            type="text"
            [placeholder]="isSearchPage ? 'Search any plate, name or initials' : 'Search'"
            [(ngModel)]="searchInput"
            (focus)="searchFocused = true"
            (blur)="searchFocused = false"
            aria-label="Search registrations"
          />
          <button class="ns-search-btn" type="submit" aria-label="Search">
            <mat-icon>&#xe8b6;</mat-icon>
          </button>
          <div class="ns-search-plate" *ngIf="searchFocused && plateMatch as reg">
            <button type="button" (mousedown)="$event.preventDefault()" (click)="goToPlate()">
              Go to the <strong>{{ reg }}</strong> plate page<span aria-hidden="true">→</span>
            </button>
            <span>Enter searches plates like {{ searchInput.trim() }}</span>
          </div>
        </form>
        <!-- Saved plates heart: desktop and mobile (prod shows it on both).
             No sign-in box: signed out it opens the device shortlist. The
             badge counts saved plates (this browser's when signed out). -->
        <button class="ns-icon ns-heart" type="button" (click)="openSaved()"
          [attr.aria-label]="savedCount ? 'Saved plates (' + savedCount + ')' : 'Saved plates'">
          <mat-icon>&#xe87e;</mat-icon>
          <span class="ns-count" *ngIf="savedCount" aria-hidden="true">{{ savedCount > 99 ? '99+' : savedCount }}</span>
        </button>
        <!-- Signed out: a plain Sign in link. Signed in: the person icon opens
             a small menu (account, saved plates, admin, sign out). -->
        <a *ngIf="!isLoggedIn" class="ns-signin" routerLink="/login" (click)="closeAll()">Sign in</a>
        <div *ngIf="isLoggedIn" class="ns-account">
          <button
            class="ns-icon"
            type="button"
            (click)="toggleAccount()"
            aria-label="Account menu"
            aria-haspopup="menu"
            [attr.aria-expanded]="accountOpen"
          >
            <mat-icon>&#xe7ff;</mat-icon>
          </button>
          <div class="ns-account-menu" *ngIf="accountOpen" role="menu">
            <a role="menuitem" routerLink="/account" (click)="closeAll()">My account</a>
            <a role="menuitem" routerLink="/account/saved" (click)="closeAll()">Saved plates</a>
            <a *ngIf="isAdmin" role="menuitem" routerLink="/account/admin" (click)="closeAll()">Admin</a>
            <button role="menuitem" type="button" class="ns-account-signout" (click)="signOut()">Sign out</button>
          </div>
        </div>
        <!-- Mobile only: magnifier drops the search bar down under the header
             (prod's mobile pattern); turns into a close icon while open. -->
        <button
          class="ns-msearch-toggle"
          type="button"
          (click)="toggleSearchBar(msearchInput)"
          aria-controls="ns-msearch"
          [attr.aria-expanded]="searchBarOpen"
          [attr.aria-label]="searchBarOpen ? 'Close search' : 'Search'"
        >
          <mat-icon *ngIf="!searchBarOpen">&#xe8b6;</mat-icon>
          <mat-icon *ngIf="searchBarOpen">&#xe5cd;</mat-icon>
        </button>
        <button class="ns-burger" type="button" (click)="openMobile()" aria-label="Open menu">
          <mat-icon>&#xe5d2;</mat-icon>
        </button>
      </div>
    </div>

    <!-- Mobile drop-down search bar (opened by the magnifier). Always in the DOM
         so the input can take focus inside the tap, which iOS needs to raise
         the keyboard; collapsed and out of the tab order while closed. -->
    <div class="ns-msearch" id="ns-msearch" [class.open]="searchBarOpen" [attr.aria-hidden]="!searchBarOpen">
      <form class="ns-msearch-form" (submit)="$event.preventDefault(); runSearch()">
        <input
          #msearchInput
          type="search"
          enterkeyhint="search"
          placeholder="Search any plate, name or initials"
          [(ngModel)]="searchInput"
          name="msearch"
          [attr.tabindex]="searchBarOpen ? 0 : -1"
          aria-label="Search registrations"
        />
        <button type="submit" aria-label="Search" [attr.tabindex]="searchBarOpen ? 0 : -1">
          <mat-icon>&#xe8b6;</mat-icon>
        </button>
      </form>
      <button
        type="button"
        class="ns-msearch-plate"
        *ngIf="searchBarOpen && plateMatch as reg"
        (click)="goToPlate()"
      >
        Go to the <strong>{{ reg }}</strong> plate page<span aria-hidden="true">→</span>
      </button>
    </div>

    <!-- desktop Search mega-menu: full-width, drops below the white header -->
    <div class="ns-mega" *ngIf="megaOpen" role="region" aria-label="Search menu">
      <div class="ns-mega-grid">
        <div class="ns-mega-col" *ngFor="let sec of megaSections">
          <div class="ns-mega-title">{{ sec.title }}</div>
          <a
            class="ns-mega-link"
            *ngFor="let l of sec.links"
            [routerLink]="l.route"
            [queryParams]="l.queryParams"
            (click)="closeAll()"
            >{{ l.label }}</a
          >
        </div>
      </div>
    </div>

    <!-- dim overlay: covers page content BELOW the header only (header stays
         bright). Outside-click closes the mega-menu. -->
    <div class="ns-overlay" *ngIf="megaOpen" (click)="closeMega()"></div>
  </header>
</div>

<!-- ============ mobile drawer (no desktop mega-menu on mobile) ============ -->
<div class="ns-mobile-backdrop" *ngIf="mobileOpen" (click)="closeMobile()"></div>
<aside class="ns-mobile" [class.open]="mobileOpen" aria-label="Menu">
  <div class="ns-mobile-head">
    <img class="ns-mobile-logo" src="assets/logo-black-text.svg" alt="PlateX" />
    <button class="ns-mobile-close" type="button" (click)="closeMobile()" aria-label="Close menu">
      <mat-icon>&#xe5cd;</mat-icon>
    </button>
  </div>

  <form class="ns-mobile-search" (submit)="$event.preventDefault(); runSearch()">
    <input
      type="text"
      placeholder="Search"
      [(ngModel)]="searchInput"
      aria-label="Search registrations"
    />
    <button type="submit" aria-label="Search"><mat-icon>&#xe8b6;</mat-icon></button>
  </form>
  <div class="ns-mobile-plate" *ngIf="plateMatch as reg">
    <button type="button" (click)="goToPlate()">
      Go to the <strong>{{ reg }}</strong> plate page<span aria-hidden="true">→</span>
    </button>
  </div>

  <nav class="ns-mobile-nav" aria-label="Mobile primary">
    <!-- expandable Search section -->
    <button
      type="button"
      class="ns-mobile-row ns-mobile-expander"
      (click)="toggleMobileSearch()"
      [attr.aria-expanded]="mobileSearchExpanded"
    >
      <span>{{ launch ? 'Search and new releases' : 'Search' }}</span>
      <mat-icon>{{ mobileSearchExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
    <div class="ns-mobile-sub" *ngIf="mobileSearchExpanded">
      <ng-container *ngFor="let sec of megaSections">
        <div class="ns-mobile-subtitle">{{ sec.title }}</div>
        <a
          class="ns-mobile-sublink"
          *ngFor="let l of sec.links"
          [routerLink]="l.route"
          [queryParams]="l.queryParams"
          (click)="closeMobile()"
          >{{ l.label }}</a
        >
      </ng-container>
    </div>

    <!-- top-level items -->
    <ng-container *ngFor="let item of topNav">
      <a
        *ngIf="item.route; else mSoon"
        class="ns-mobile-row"
        [routerLink]="item.route"
        [queryParams]="item.queryParams"
        (click)="closeMobile()"
        >{{ item.label
        }}<span class="ns-live" *ngIf="item.live && liveCount !== null"><i></i>{{ liveCount }}</span></a
      >
      <ng-template #mSoon>
        <span class="ns-mobile-row ns-mobile-row--soon"
          >{{ item.label }}<span class="ns-soon">soon</span></span
        >
      </ng-template>
    </ng-container>

    <!-- account: the header account/saved icons are display:none at the mobile
         breakpoint, so these rows are the only mobile path to /account — and,
         for admins, to /account/admin. -->
    <div class="ns-mobile-subtitle">Account</div>
    <a *ngIf="!isLoggedIn" class="ns-mobile-row" routerLink="/login" (click)="closeMobile()">Sign in</a>
    <a class="ns-mobile-row" routerLink="/account" (click)="closeMobile()">My Account</a>
    <button type="button" class="ns-mobile-row" (click)="openSaved()">Saved plates</button>
    <a *ngIf="isAdmin" class="ns-mobile-row" routerLink="/account/admin" (click)="closeMobile()">Admin</a>
    <button *ngIf="isLoggedIn" type="button" class="ns-mobile-row ns-mobile-signout" (click)="signOut()">Sign out</button>
  </nav>
</aside>
